/* import __COLOCATED_TEMPLATE__ from './signup-chip-selector-basic.hbs'; */
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { createCache, getValue } from '@glimmer/tracking/primitives/cache';
import Component from '@glimmer/component';
import clsx from 'clsx';

/**
 * @param {HTMLElement} element
 * @returns {CanvasRenderingContext2D}
 */
const createContext = (element) => {
  const { fontSize, fontFamily } = window.getComputedStyle(element);

  const context = document
    .createElement('canvas')
    .getContext('2d');

  context.font = `${fontSize} ${fontFamily}`;
  return context;
};

const EMPTY_OPTIONS = [ ];

/** @module */
class SignupChipSelectorBasic extends Component {
  @tracked context = null;
  @tracked placeHolderWidth = -1;
  @tracked inputWidth = -1;

  #textWidthCache = createCache(() => {
    return this.context?.measureText(this.args.value ?? '').width ?? -1;
  });

  get textWidth() {
    return getValue(this.#textWidthCache);
  }

  get forceNewLine() {
    // element hasn't been inserted yet
    if (this.inputWidth === -1) {
      return false;
    }

    if (!this.args.selected?.length) {
      return false;
    }

    return (this.placeHolderWidth === -1)
      ? this.textWidth > this.inputWidth
      : this.textWidth > this.placeHolderWidth;
  }

  get selected() {
    return this.args.selected ?? EMPTY_OPTIONS;
  }

  get isActive() {
    return this.selected.length > 0;
  }

  get showChevron() {
    return this.args.showChevron ?? true;
  }

  get chipContainerClassNames() {
    return clsx(
      'signup-input__chip-container',
      this.showChevron && 'signup-input__chip-container--padded',
    );
  }

  get chipClassNames() {
    return clsx(
      'signup-input__chip',
      this.args.disabled && 'signup-input__chip--disabled',
    );
  }

  @action
  refCallback(element) {
    if (element) {
      this.context = createContext(element);
    }
  }

  @action
  inputResize(size) {
    this.inputWidth = size?.width ?? -1;
  }

  @action
  placeholderResize(size) {
    this.placeHolderWidth = size?.width ?? -1;
  }

  /**
   * @param {KeyboardEvent} e
   */
  @action
  handleKeyDown(e) {
    this.args.onkeydown?.(e);

    if (e.defaultPrevented) {
      return;
    }

    switch (e.key) {
      case 'Backspace':
        const { value }  = this.args;
        const { selected } = this;

        if (!value && selected.length > 0) {
          this.args.onremoved?.(selected[selected.length - 1])
        }

        break;
    }
  }

  /**
   *
   */
  @action
  handleRemove(option) {
    if (!this.args.disabled) {
      this.args.onremoved?.(option);
    }
  }

  /**
   * @param {MouseEvent} e
   */
  @action
  cancelBlur(e) {
    if (!this.args.disabled) {
      e.preventDefault();
    }
  }
}

export default SignupChipSelectorBasic;
